import React, { Component } from 'react'
import Client from '../ContentFul';

const RecentJobsContext = React.createContext();


class JobsProvider extends Component{
    state = {
        jobs:[],
        loading:true
    };


    getData = async () => {
        try {
            let response = await Client.getEntries({content_type:"jobs"});
            let jobs = this.formatAPIs(response.items)
            const sortedJobs = jobs.sort( (a,b) => {
                const ar = a.order - b.order;
                return ar
            } )
            sortedJobs.reverse()
            this.setState({
                jobs:sortedJobs,
                loading:false
            })
        } catch (error) {
            console.log(error);
        }
    }


    formatAPIs = items => {
        let tempAPI = items.map(item => {
            let id = item.sys.id;
            let images = item.fields.companyLogo.fields;
            let data = {...item.fields,images,id}
            return data;
        })
        return tempAPI;
    }

 

    componentDidMount(){
        this.getData();
    }


    render(){
        return (
            <div>
                {/* <PortfolioContext.Provider value={this.state}>  the same thiing if use speread operator*/}
                <RecentJobsContext.Provider value={{...this.state,getData:this.getData}}>
                    {this.props.children}
                </RecentJobsContext.Provider>
            </div>
        )
    }
}

export {JobsProvider,RecentJobsContext}
